import React from 'react';
import { withTranslation, Trans } from 'react-i18next';

import { MUIModal, Flex, Image, Text, ButtonFilled } from 'Components/Base';
import { useConfig } from 'Context/ConfigContext';

const TimeoutBlockNavigationDialog = ({ t, onAcceptTimeout, ...props }) => {
  const {
    classroom: { quiz = {} },
  } = useConfig();
  const { imagePrefix = '', imageSuffix = 'svg' } = quiz;

  return (
    <MUIModal
      modalStyle={{ padding: '36px', borderRadius: '16px', maxWidth: '340px' }}
      fullWidth={true}
      maxWidth={'xs'}
      closeIcon={false}
      {...props}
    >
      {(openModal, closeModal) => {
        const handleCloseModal = () => {
          typeof onAcceptTimeout === 'function' && onAcceptTimeout();
          closeModal();
        };
        return (
          <Flex flexDirection={'column'} alignItems={'center'} style={{ gap: '24px' }}>
            <Image
              src={`/assets/images/quiz/${imagePrefix}quiz-timeout.${imageSuffix}`}
              width={'70px'}
              style={{ margin: '24px' }}
            />
            <Text textStyle={'heading2'} fontWeight={400}>
              {t('TIMEOUT_MODAL.TITLE')}
            </Text>
            <Text textAlign="center">
              <Trans defaults={t('TIMEOUT_MODAL.SUBTITLE')} components={[<br key="subTitle" />]} />
            </Text>
            <ButtonFilled width={1} type="button" borderRadius="8px" onClick={handleCloseModal}>
              <Text textStyle={'body1'} fontWeight={700}>
                {t('TIMEOUT_MODAL.REVIEW_ANSWER')}
              </Text>
            </ButtonFilled>
          </Flex>
        );
      }}
    </MUIModal>
  );
};

export default withTranslation('quiz')(TimeoutBlockNavigationDialog);
